import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import HomeView from "@/pages/HomeView";
import AppDetailView from "@/pages/AppDetailView";
import CollectionsView from "@/pages/CollectionsView";
import CategoryView from "@/pages/CategoryView";
import SearchView from "@/pages/SearchView";
import AdminView from "@/pages/AdminView";
import BottomNav from "@/components/BottomNav";
import ProstoApp from "@/prosto/ProstoApp";
import { api, captureWb } from "@/lib/api";
import { installTracker, track, pageLabel } from "@/lib/track";
import { getTelegramWebApp, initializeTelegramWebApp } from "@/lib/telegram";

function RouteTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    try {
      if (!pathname.startsWith("/admin")) track("view", pageLabel(pathname));
    } catch (error) {
      console.warn("Could not track route", error);
    }
  }, [pathname]);
  return null;
}

function AppWayShell() {
  useEffect(() => {
    const tg = getTelegramWebApp();
    if (tg) {
      try {
        tg.setBackgroundColor("#0b0e14");
        tg.setHeaderColor("#0b0e14");
      } catch (e) {
        /* older clients */
      }
    }
  }, []);

  return (
    <div className="dark">
      <div className="app-shell">
        <Routes>
          <Route index element={<HomeView />} />
          <Route path="app/:id" element={<AppDetailView />} />
          <Route path="collections" element={<CollectionsView />} />
          <Route path="category/:name" element={<CategoryView />} />
          <Route path="search" element={<SearchView />} />
          <Route path="admin" element={<AdminView />} />
        </Routes>
        <BottomNav />
      </div>
    </div>
  );
}

function App() {
  useEffect(() => {
    try {
      captureWb();
    } catch (error) {
      console.warn("Could not read Mini App start parameters", error);
    }
    api.wbOpen().catch(() => {});
    try {
      if (!window.location.pathname.startsWith("/admin")) installTracker();
    } catch (error) {
      console.warn("Could not initialize analytics", error);
    }
    const initializeTelegram = () => initializeTelegramWebApp();
    window.addEventListener("telegram-webapp-ready", initializeTelegram);
    initializeTelegram();
    return () => window.removeEventListener("telegram-webapp-ready", initializeTelegram);
  }, []);

  return (
    <>
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          <Route path="/prosto/*" element={<ProstoApp />} />
          <Route path="/*" element={<AppWayShell />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme={window.location.pathname.startsWith("/prosto") ? "light" : "dark"} position="top-center" richColors />
    </>
  );
}

export default App;
